import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { getPageTitle } from 'store/search/searchSelectors';
import { SEARCH_PAGE_META } from 'lib/enums/search';

const MapSearchHelmet = () => {
  const title = useSelector(getPageTitle);

  return <Helmet title={title} meta={SEARCH_PAGE_META} />;
};

export default MapSearchHelmet;
